import React from 'react';
import HotelList from '../HotelComponents/HotelList';
import Banner from '../CommonComponents/Banner';
import Drake from "../assets/images/drake-hotel.jpg";
import Germain from "../assets/images/Le-Germain_Hotel_Montreal_Lifestyle.png";
import Fairmont from "../assets/images/fairmont_royal_york.jpg";
import Saint from "../assets/images/Saint-James.webp";
import Monville from "../assets/images/Hotel-Monville.jpg";
import Header from '../LayoutComponents/Header';
import Footer from '../LayoutComponents/Footer';
const BoutiqueHotels = () => {
  const boutiqueHotels = [
    {
      name: "The Drake Hotel",
      image: Drake,
      location: "Toronto, Ontario",
      overview: "The Drake Hotel is a trendy boutique hotel known for its eclectic decor and vibrant atmosphere in Toronto's West Queen West neighborhood.",
      rooms: "The hotel offers uniquely designed rooms with a mix of modern and vintage elements. Each room includes free Wi-Fi, flat-screen TVs, and stylish furnishings.",
      dining: "The hotel features a popular restaurant and bar known for its creative menu and lively ambiance. Guests can enjoy a variety of dining options and signature cocktails.",
      facilities: "The Drake Hotel boasts a rooftop patio, live music events, and art exhibitions. The hotel also offers a 24-hour front desk and concierge services.",
      service: "The friendly and artistic staff provide a warm and welcoming experience, enhancing the hotel's unique character.",
      experience: "The Drake Hotel offers a distinctive and vibrant boutique experience, perfect for those seeking a stylish and creative stay in Toronto."
    },
    {
      name: "Le Germain Hotel Montreal",
      image: Germain,
      location: "Montreal, Quebec",
      overview: "Le Germain Hotel Montreal combines modern luxury with boutique charm in the heart of downtown Montreal.",
      rooms: "The hotel's rooms feature contemporary decor, high-speed internet, flat-screen TVs, and plush bedding. Many rooms offer city views.",
      dining: "The hotel offers a complimentary breakfast with a selection of gourmet items, and guests can enjoy nearby dining options in Montreal's culinary scene.",
      facilities: "Le Germain features a fitness center, meeting rooms, and a stylish lounge area. The hotel's central location provides easy access to major attractions.",
      service: "The attentive staff deliver personalized service, ensuring a comfortable and enjoyable stay.",
      experience: "Le Germain Hotel Montreal offers a blend of modern luxury and boutique charm, making it a great choice for a stylish stay in Montreal."
    },
    {
      name: "The Fairmont Royal York",
      image: Fairmont,
      location: "Toronto, Ontario",
      overview: "The Fairmont Royal York is a historic boutique hotel offering elegant accommodations and exceptional service in downtown Toronto.",
      rooms: "The hotel offers beautifully appointed rooms with classic decor, high-speed internet, flat-screen TVs, and luxurious bedding.",
      dining: "The hotel features several dining options, including a formal restaurant, a casual café, and a stylish lounge. Guests can enjoy a variety of culinary experiences.",
      facilities: "The Fairmont Royal York boasts a fitness center, an indoor pool, and a full-service spa. The hotel also offers event spaces and concierge services.",
      service: "The professional staff provide excellent service, ensuring a refined and comfortable stay.",
      experience: "The Fairmont Royal York combines historic charm with modern luxury, offering a sophisticated boutique experience in Toronto."
    },
    {
      name: "The Saint James Hotel",
      image: Saint,
      location: "Montreal, Quebec",
      overview: "The Saint James Hotel offers a blend of classic elegance and modern comfort in the heart of Montreal.",
      rooms: "The hotel's rooms feature traditional decor with modern amenities, including high-speed internet, flat-screen TVs, and plush bedding.",
      dining: "The hotel offers a gourmet restaurant with a selection of fine dining options. Guests can also enjoy a stylish bar and lounge area.",
      facilities: "The Saint James Hotel includes a fitness center, meeting rooms, and a business center. The hotel's central location provides easy access to Montreal's attractions.",
      service: "The attentive staff offer personalized service, enhancing the hotel's classic and comfortable ambiance.",
      experience: "The Saint James Hotel provides an elegant and comfortable boutique stay in Montreal, ideal for those seeking a blend of tradition and modern luxury."
    },
    {
      name: "Hotel Monville",
      image: Monville,
      location: "Montreal, Quebec",
      overview: "Hotel Monville offers a contemporary boutique experience with innovative design and modern amenities in Montreal.",
      rooms: "The hotel features sleek, modern rooms with high-speed internet, flat-screen TVs, and stylish furnishings. Many rooms offer panoramic city views.",
      dining: "Hotel Monville includes a trendy restaurant and bar known for its contemporary menu and creative cocktails. Guests can enjoy a vibrant dining experience.",
      facilities: "The hotel features a fitness center, meeting rooms, and a rooftop terrace. The hotel's central location provides easy access to local attractions.",
      service: "The friendly and professional staff offer attentive service, ensuring a memorable and comfortable stay.",
      experience: "Hotel Monville provides a modern and stylish boutique experience, making it an excellent choice for travelers seeking contemporary luxury in Montreal."
    }
  ];

  return (
    <>
    <Header />
      <Banner 
        title="<span>Discover</span> Unique Charm: <span>Top Boutique</span> Hotels in New Zealand"
        description="Step into the world of personalized luxury and Scandinavian elegance with cloudmingle's guide to New Zealand's finest boutique hotels. Our reviews showcase properties that blend style, character, and exceptional service to create unforgettable experiences. From cozy fjord retreats to contemporary city escapes, these boutique gems offer a distinct and intimate stay. Explore our curated selection and find the perfect boutique hotel for your Norwegian adventure."
      />
      <HotelList hotels={boutiqueHotels} />
            <Footer />
      
    </>
  );
};

export default BoutiqueHotels;